<h3>Shopping Cart</h3>
<div>#Items: {{data.order.items.length}}</div>
<div>Subtotal: {{data.order.subtotal | currency: "USD":true}}</div>
<table>
    <thead>
    <tr>
        <td><h4>Producto</h4></td>
        <td><h4>Cantidad</h4></td>
        <td><h4>Precio</h4></td>
        <td><h4>Total</h4></td>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let o of data.order.items">
        <td>{{o.productCategory}} - {{o.productTitle}}</td>
        <td>{{o.quantity}}</td>
        <td>{{o.unitPrice | currency: "USD":true}}</td>
        <td>{{(o.unitPrice * o.quantity)| currency: "USD":true}}</td>
    </tr>
    </tbody>
</table>
<button routerLink="checkout" *ngIf="data.order.items.length>0" (click)="onCheckout()">Checkout</button>